export default {
    methods: {
        checkEffectiveDate(insurance) {
            let effectiveDateString = insurance && insurance.details && insurance.details.effective_date,
                today = this.moment(),
                effectiveDate = null;
            if (effectiveDateString) {
                effectiveDate = this.moment(effectiveDateString);
            } else {
                return false;
            }

            today.set('hour', 0);
            today.set('minute', 0);
            today.set('second', 0);

            return today < effectiveDate;
        },
        checkEffectiveDateMutuaide(insurance) {
          let effectiveDateString = insurance && insurance.effective_date,
            today = this.moment(),
            effectiveDate = null;
          if (effectiveDateString) {
            effectiveDate = this.moment(effectiveDateString);
          } else {
            return false;
          }

          today.set('hour', 0);
          today.set('minute', 0);
          today.set('second', 0);

          return today < effectiveDate;
        },
        checkSubscription(quote, getPdfMethod) {
            this.apiGet(`garantie/check_subscription/${quote.id}`)
                .then(response => {
                    if (response.data.status === 'unsubscribed') {
                        getPdfMethod();
                    } else {
                        this.showErrorNotificationText('Vous avez déja souscrit à la garantie. Veuillez verifier dans vos garanties souscrites.', null);
                    }
                })
                .catch(error => this.showErrorNotification(error));
        },
        checkMutuaideSubscription(quote, getPdfMethod) {
          this.apiGet(`garantie/check_mutuaide_subscription/${quote.id}`)
            .then(response => {
              // alert(response.data.status);
              if (response.data.status === 'unsubscribed') {
                getPdfMethod();
              } else {
                this.showErrorNotificationText('Vous avez déja souscrit à la garantie. Veuillez verifier dans vos garanties souscrites.', null);
              }
            })
            .catch(error => this.showErrorNotification(error));
        },
        getInsuranceSubscription(insurance, getPdfMethod, paymentType = 'year') {
            this.apiGet(`insurances/check-insurance-subscription/${insurance.id}?t=${paymentType}`)
                .then(response => {
                    if (response.data.status === 'unsubscribed') {
                        getPdfMethod();
                    } else {
                        this.showErrorNotificationText('Vous avez déja souscrit à la garantie. Veuillez verifier dans vos garanties souscrites.', null);
                    }
                })
                .catch(error => this.showErrorNotification(error));
        },
    }
}



// WEBPACK FOOTER //
// ./src/mixins/insuranceMethods.js